import React from 'react';
import { Box, Typography } from '@mui/material';

function NotFound() {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant='h1'>404 - Not Found</Typography>
      <Typography variant='body1'>
        The page you're looking for does not exist.
      </Typography>
    </Box>
  );
}

export default NotFound;
